module.exports = __webpack_public_path__ + "static/media/burger-logo.b8503d26.png";